module.exports = __webpack_public_path__ + "static/grid-image-lg-e2d1519f614e20058397778fbf03e2d1.png";